<template>
    <div>
        <div class="flex flex-wrap items-center justify-end mb-4 mt-base">
            <vs-button @click="aceptar" class="mt-2 ml-auto" icon-pack="feather" color="warning" icon="icon-refresh-cw">Actualizar</vs-button>
        </div>
        <div class="items-grid-view vx-row match-height" v-if="itemsProyectos.length" appear>
            <div class="w-full vx-col lg:w-1/4 md:w-1/3 sm:w-1/2" v-for="item in itemsProyectos" :key="item.meta">
                <proyecto-grid-view :item="item">
                    <template slot="action-buttons">
                        <div class="flex flex-wrap">
                            <div
                                class="flex items-center justify-center flex-grow p-3 text-white cursor-pointer item-view-secondary-action-btn bg-danger"
                                @click="navigate_to_detail_view(item.id)">
                                <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" />
                                <span class="ml-2 text-sm font-semibold">Ver</span>
                            </div>
                        </div>
                    </template>
                </proyecto-grid-view>
            </div>
        </div>
    </div>
</template>
<script>
import ProyectoGridView from './ProyectoGridView.vue';
export default {
    components: {
        ProyectoGridView
    },

    data(){
        return {
            itemsProyectos: []
        }
    },

    mounted(){
        //this.listarMetas();
    },

    methods: {
        listarMetas(){
            this.$vs.loading();
            this.$http.metasPorPerfil()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsProyectos = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        aceptar(){
            this.itemsProyectos = [];
            this.listarMetas();
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.popupRiesgo = false;
                this.popupEliminar = false;
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupRiesgo = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },

    }
}
</script>
<style lang="scss" scoped>

</style>